import QueryBuilder from "../QueryBuilder"

export default class CalloutRepository {
    constructor(protected contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, [
                "bannerText",
                "text_highlight",
                "subheaderText",
                "cta_enabled",
                "cta_text",
                "cta_redirection",
                "'image': imagePanel",
            ])
            .process()

        return results.getResultInfo()
    }
}
